import api from "./api";

export async function getReferenciels(
    referencielIds?: (number | null)[]
): Promise<any | null> {
    let url = "api/referenciel/";
    if (referencielIds && referencielIds.length) {
        url += `?ids=${referencielIds.join(",")}`;
    }

    return await api
        .get(url)
        .then((response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            return response.data;
        })
        .catch((e: Error) => {
            const error = e.message ? e : JSON.parse(e.message);

            if (error.response) {
                return error.response.data;
            }
            return error;
        });
}

export async function getRegionByNetworkId(
    networkSelected: number
): Promise<any | null> {
    if(networkSelected === 0){
        return [];
    }
    let url = `api/establishment-group/${networkSelected}/regions`;
    return await api.get(url).then(
        (response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            return response.data;
        }
    ).catch((e: Error) => {
        
        const error = e.message ? e : JSON.parse(e.message);
        
        
        if(error.response) {
            return error.response.data;
        }
        
        return error;
    });
}